module.exports = __webpack_public_path__ + "media/img/support/contacts-fr-79212c8d4c8f8e7db83a6cb65d0be200.jpg";